const rules = function () {
    return {
        insBillId: {
            required: true,
            message: '请选择退统日期',
            trigger: 'change'
        },
        return_date: {
            required: true,
            message: '请选择退统日期',
            trigger: 'change'
        },
        cost: {
            required: true,
            message: '请输入退统费用',
            trigger: 'change'
        },
        days: {
            required: true,
            message: '请输入退统天数',
            trigger: 'change'
        },
        actual_cost: {
            required: true,
            message: '请输入实退费用',
            trigger: 'change'
        },
        apply_remark: {
            required: true,
            message: '请输入备注',
            trigger: 'change'
        },
    }
}


module.exports = {
    rules
}